import { encrypt } from "../../../Core/utils/others";

export const PREMIUM_POPUP_TYPE = { UPGRADE_NOW: 1, PAYMENT_REQUIRED: 2 };

export const HAS_SEEN_UPGRADE_NOW_KEY = "hasSeenUpgradeNowPopup";

/**
 * Writes what GET /student/dashboard/stats tells the session: the student (with
 * their Sandbox subscription) as `sandbox_user_data`, and `linkedUser`, which
 * Evaluation and the app header read for the student's id and grade. Guests get
 * their own keys.
 *
 * @param {object} res - the stats response
 * @param {string} role
 * @returns {object[]} the subscriptions to check for a premium popup, in order
 */
export const applyStatsToSession = (res, role) => {
  const subscriptions = [];
  const student = res?.data?.student;
  const guestInfo = res?.data?.guestInfo;

  if (student) {
    localStorage.setItem("sandbox_user_data", encrypt(student));
    subscriptions.push(student.subscription);
  }
  if (role === "guest" && res?.data?.isGuestMentor) {
    localStorage.setItem("isGuestMentor", res.data.isGuestMentor === 1 ? "1" : "0");
  }
  if (role === "guest" && guestInfo) {
    if (guestInfo.subscription) {
      localStorage.setItem("sandbox_user_data", encrypt({ subscription: guestInfo.subscription }));
      subscriptions.push(guestInfo.subscription);
    }
    localStorage.removeItem("linkedUser");
    if (guestInfo.linkedUserId) {
      localStorage.setItem(
        "linkedUser",
        encrypt({
          userType: guestInfo.userType,
          userId: guestInfo.linkedUserId,
          grade: guestInfo.grade,
          subscription: guestInfo.subscription,
        }),
      );
    }
  } else if (role !== "guest" && student) {
    localStorage.setItem("linkedUser", encrypt({ userId: student.studentId, grade: student.grade }));
  }

  return subscriptions.filter(Boolean);
};

/**
 * Which premium popup a Sandbox subscription calls for: the blocking one once
 * payment is due, the one-time "upgrade now" one before that, or none.
 * @param {{ paymentRequired?: boolean, upgradeNow?: boolean }} subscription
 * @returns {1|2|null}
 */
export const premiumPopupTypeFor = (subscription) => {
  if (subscription?.paymentRequired === true) return PREMIUM_POPUP_TYPE.PAYMENT_REQUIRED;
  if (subscription?.upgradeNow === true && !localStorage.getItem(HAS_SEEN_UPGRADE_NOW_KEY)) {
    return PREMIUM_POPUP_TYPE.UPGRADE_NOW;
  }
  return null;
};
